<template>
    <div class="attached-item">
        <div class="attached-item__title">
            <h3 class="text-normal font-medium mb-2.5">{{ attachmentName }}</h3>
        </div>
        <Component
            :is="cardType"
            :item="attachment"
            :attachment-type="attachmentType"
        />
    </div>
</template>

<script>
import FlatFee from '@/BuyNow/Components/AttachmentTypes/FlatFee.vue';
import PerUnit from '@/BuyNow/Components/AttachmentTypes/PerUnit.vue';
import Stairstep from '@/BuyNow/Components/AttachmentTypes/Stairstep.vue';

export default {
    data() {
        return {
        };
    },
    components: {
        FlatFee,
        PerUnit,
        Stairstep,
    },
    mounted() {
    },
    props: {
        attachment: Object,
        attachmentType: String
    },
    methods: {
    },
    created() {
    },
    computed: {
        selectedPricing() {
            let found;
            if (this.attachment.pricing.length > 1) {
                found = this.attachment.pricing.find((price) => {
                    return price.billingPeriodUnit === this.$store.getters.cartInfo.billingPeriod;
                });
            } else {
                found = this.attachment.pricing[0];
            }
            return found;
        },
        cardType() {
            switch(this.selectedPricing.model) {
                case 'per_unit':
                    return 'PerUnit';
                case 'stairstep':
                    return 'Stairstep';
                case 'flat_fee':
                    return 'FlatFee';
            }
        },
        attachmentName() {
            return this.attachment.metadata?.title ?? this.attachment.name;
        },
        attachmentDescription() {
            return this.attachment.metadata.description ?? this.attachment.description;
        },
        attachmentPricing() {
            const price = this.attachment.pricing.find((price) => {
                return price.billingPeriodUnit === this.$store.getters.cartInfo.billingPeriod;
            }).tiers[0];

            return price.unitPrice / 100;
        },
    },
    watch: {
    }
};
</script>

<style lang="postcss" scoped>
</style>
